/*!
 * @license
 * SPDX-License-Identifier: LicenseRef-cloudEQ-Proprietary
 * Copyright (c) 2026-present cloudEQ Inc. All Rights Reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL.
 *
 * This source code, including all associated files, documentation, and
 * compiled forms, is the exclusive property of cloudEQ Inc. and is
 * protected by copyright, trade secret, and other intellectual property laws.
 *
 * This software is licensed, not sold, solely for use by authorized
 * licensees under the terms of a written license agreement with
 * cloudEQ Inc. Unless expressly permitted by that agreement, you may not
 * copy, modify, merge, distribute, sublicense, sell, publish, reverse
 * engineer, decompile, disassemble, or create derivative works of this
 * software, in whole or in part, by any means.
 *
 * Access to this file does not grant any license or right to use it.
 * Unauthorized use, reproduction, or disclosure is strictly prohibited and
 * may result in civil and criminal penalties.
 *
 * Contact: legal@cloudeq.com
 */

/**
 * The app's icons, all from one set.
 *
 * **Why this file changed.** Every icon in the app used to be an inline `<svg>`
 * with hand-written paths — 40 of them across 19 files, drawn at **eight
 * different stroke widths**: 1.6, 1.8, 1.9, 2, 2.2, 2.4, 2.6 and 3. On a single
 * card the paperclip, the speech bubble and the calendar were three of those
 * weights side by side. It is the clearest example in this app of something that
 * reads as unpolished while being almost impossible to describe: the eye
 * registers "slightly wrong" and cannot say why. Nothing measured it and no
 * review would have caught it, which is how it reached eight.
 *
 * `lucide-react` is the successor to Feather, which is visibly what most of
 * these paths were already imitating — so this is less a change of look than the
 * look they were reaching for, drawn consistently. It is tree-shaken per icon,
 * so only what is imported ships.
 *
 * **One exception stays hand-written: the Microsoft logo** on the sign-in
 * button. Four coloured squares in somebody else's brand colours are not an
 * icon, and no icon set gets to reinterpret them.
 *
 * The two wrappers below keep their old names because a card and a list row both
 * import them; what is inside is now lucide.
 */
import { MessageCircle, Paperclip } from 'lucide-react';

export function PaperclipIcon() {
  return <Paperclip className="size-3.5 shrink-0" aria-hidden />;
}

export function MessageIcon() {
  return <MessageCircle className="size-3.5 shrink-0" aria-hidden />;
}
